export const SET_QUICK_START_STATE = 'SET_QUICK_START_STATE'
export const RESET_QUICK_START_STATE = 'RESET_QUICK_START_STATE'
export const SET_ANNOUNCEMENT_STATE = 'SET_ANNOUNCEMENT_STATE'

// Thread Actions
export const SET_NEW_THREAD_MODAL_VISIBILITY =
  'SET_NEW_THREAD_MODAL_VISIBILITY'

// Tracked Actions
export const TRACKED_ACTIONS = {
  SET_ANNOUNCEMENT_STATE,
}
